import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { CoreRoutingModule } from './core-routing.module';
import { MaterialModule } from '../shared/module/material/material.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthService } from '@app-services/auth-service/auth.service';
import { AuthGuard } from './components/guards/auth.guard';
import { CookieService } from 'ngx-cookie-service';
import { SignupService } from '@app-services/signup/signup.service';
import { HttpConfigInterceptor } from '@app-services/new-interceptor/new-interceptor';
import { CompleteProfileComponent } from './components/complete-profile/complete-profile.component';
import { DefaultLayoutComponent } from './components/layout/default-layout/default-layout.component';
import { LiveClassLayoutComponent } from './components/layout/live-class-layout/live-class-layout.component';
import { LiveClassHeaderComponent } from './components/live-class-header/live-class-header.component';
import { ClassLayoutComponent } from './components/layout/class-layout/class-layout.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TeacherHomeComponent } from './components/teacher-home/teacher-home.component';
import { NewHeaderComponent } from './components/new-header/new-header.component';
import { CoursesModule } from '@app-modules/feature/courses/courses.module';
import { ScoreActionsComponent } from '@app-shared/components/score-actions/score-actions.component';

@NgModule({
  declarations: [
    CompleteProfileComponent,
    // HeaderComponent,
    DefaultLayoutComponent,
    LiveClassLayoutComponent,
    LiveClassHeaderComponent,
    ClassLayoutComponent,
    TeacherHomeComponent,
    NewHeaderComponent,
    ScoreActionsComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    CoreRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    CoursesModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  providers: [
    // PwaUpdateService,
    AuthService,
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
    // LoginService,
    SignupService,
    CookieService,
  ],
  exports: [
    // HeaderComponent    
  ]
})
export class CoreModule { }
